export const TYPE = {
  LOW: 'lowContainersCount',
  HIGH: 'highContainersCount',
};

export const TYPES = Object.values(TYPE);
